import React, { useState } from 'react';
import { Retry } from '../common';
import Table from '../common/Table';
import { DrawerTitle, RCATablesContainer, TraceIdItem } from './styled';
import { useRCA } from './utils/useRCA';
import { useSelector } from 'react-redux';
import { chartIntervalSelector } from '@src/store/trends/birdChart/selectors';
import { metricFilterSelector } from '@src/store/trends/base/selectors';
import {
  addRCADimension,
  formatMultiData,
  formatRCAColumns,
  genNetworkRequestUrl,
} from './utils/formatColumn';
import { compositeNetworkRequestUrlDimenison, rcaMetrics } from './utils/constant';
import { metricKeys } from '@pulse/metrics';
import { getMetricFilterMetric } from '../dimension-panel-hz/dimension-table/utils';
import { Drawer, Tooltip, message } from 'antd';
import { useTraceId } from './utils/useTraceId';
import { filterSelector } from '@src/store/common/selectors';
import { CopyOutlined } from '@ant-design/icons';
import copy from 'copy-to-clipboard';
import { useAtom } from 'jotai';
import { traceIdInfoAtom } from './utils/atom';

export const RCATables = () => {
  const interval = useSelector(chartIntervalSelector);
  const metricFilter = useSelector(metricFilterSelector);
  const filter = useSelector(filterSelector);
  const [sortBy, setSortBy] = useState({
    key: `${getMetricFilterMetric(metricKeys.AverageRequestDuration)}`,
    order: 'desc',
  });
  const [traceIdInfo, setTraceIdInfo] = useAtom(traceIdInfoAtom);
  const {
    data: traceIdData,
    isLoading: isTraceIdLoading,
    refetch: refetchTraceId,
    isError: isTracdIdError,
  } = useTraceId(interval, metricFilter, filter, traceIdInfo.info);
  const { data, isLoading, refetch, isError } = useRCA(interval, metricFilter, filter);

  const { rows } = formatMultiData({
    data,
    sortBy,
    searchText: '',
  });

  const tableRows = addRCADimension(rows, data?.rcaData);

  const columns = formatRCAColumns({
    dimension: compositeNetworkRequestUrlDimenison,
    metrics: rcaMetrics,
  });

  const onColumnSort = ({ key, order }) => {
    setSortBy({ key, order });
  };

  const handleDrawerClose = () => {
    setTraceIdInfo({ ...traceIdInfo, open: false });
  };

  const handleCopy = (id) => {
    if (copy(id)) {
      message.info('Copied to clipboard');
    }
  };

  const drawerTitle = (
    <Tooltip
      title={`Trace ID of "${genNetworkRequestUrl(traceIdInfo.info)}"`}
      overlayInnerStyle={{ width: '800px' }}
      placement="topLeft"
    >
      <DrawerTitle>{`Trace ID of "${genNetworkRequestUrl(traceIdInfo.info)}"`}</DrawerTitle>
    </Tooltip>
  );

  return (
    <>
      <RCATablesContainer>
        <Retry
          fetchData={refetch}
          isLoading={isLoading}
          showError={isError}
          isEmpty={tableRows.length === 0}
          progress={true}
        >
          <Table
            columns={columns}
            data={tableRows}
            headerHeight={50}
            rowHeight={45}
            sortBy={sortBy}
            onColumnSort={onColumnSort}
          />
        </Retry>
      </RCATablesContainer>
      <Drawer
        title={drawerTitle}
        placement="bottom"
        closable={true}
        onClose={handleDrawerClose}
        open={traceIdInfo.open}
      >
        <Retry
          fetchData={refetchTraceId}
          isLoading={isTraceIdLoading}
          showError={isTracdIdError}
          isEmpty={!traceIdData || traceIdData?.length === 0}
        >
          {(traceIdData ?? []).map((id) => (
            <TraceIdItem key={id}>
              {id}
              <CopyOutlined style={{ marginLeft: '8px' }} onClick={() => handleCopy(id)} />
            </TraceIdItem>
          ))}
        </Retry>
      </Drawer>
    </>
  );
};
